import isNil from 'lodash/isNil'
import React from 'react'
import { ChatAttachments } from '../ChatAttachments'
import { Avatar, HorizontalStack, ShowIf, Switch } from '@ztechapps/webui.util'
import type { ChatMessageProps } from '../chatComponents'
import { InternalNoteBadge, internalNoteClassName } from './InternalNoteBadge'
import { isInternalNoteMessage } from './isInternalNoteMessage'
import { MessageTimeStamp } from './MessageTimeStamp'

export const ChatMessage = ({
  from,
  timeStamp,
  content,
  currentUser,
  attachments,
  isLeft,
  children,
  borderStyle = 'border',
  isPublic,
  externalId,
}: ChatMessageProps) => {
  isLeft = isNil(isLeft) ? currentUser?._id === from?._id : isLeft
  const isInternalNote = isInternalNoteMessage({ isPublic, externalId })

  return (
    <HorizontalStack
      gap={4}
      className={`align-items-start ${isInternalNote ? internalNoteClassName : borderStyle} px-2 py-3 chat-message ${isLeft ? 'left' : 'right'}`}
    >
      <Avatar src={from?.profile?.picture} name={from?.profile?.name} size={50} />
      {/* The content column is the avatar's flex sibling: its default `min-width: auto` holds it as
          wide as its longest unbreakable run (an attachment link), stretching the row past a phone
          viewport and keeping the timestamp beside the name. Bootstrap ships no `min-w-0` utility,
          so the one-off value is inline style. */}
      <div className="flex-fill" style={{ minWidth: 0 }}>
        <HorizontalStack gap={2} className="justify-content-between flex-wrap mb-2">
          <div className=" text-primary fw-bold">
            {from?.profile?.name}
            <ShowIf condition={isInternalNote}>
              <InternalNoteBadge />
            </ShowIf>
          </div>
          <MessageTimeStamp value={timeStamp} />
        </HorizontalStack>

        <Switch expression={!isNil(children)}>
          {{
            true: children,
            false: <span>{content}</span>,
          }}
        </Switch>

        <ChatAttachments attachments={attachments} />
      </div>
    </HorizontalStack>
  )
}
